import { Market, NearbyMarketData, NearbyMarketsFeatureCollection, SearchResponse } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const marketsApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    getMarkets: builder.query<SearchResponse<Market>, { adm0code: number; query?: string; skip: number; top: number }>({
      query: ({ adm0code, query, skip, top }) => ({
        url: `Markets/Get`,
        method: "GET",
        params: { adm0Code: adm0code, search: query || undefined, skip, top },
      }),
      providesTags: [{ type: "Markets" as const, id: "LIST" }],
    }),

    addMarket: builder.mutation<void, Partial<Market>>({
      query: body => ({
        url: "Markets/Post",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Markets", id: "LIST" }],
    }),

    updateMarket: builder.mutation<void, Partial<Market>>({
      query: body => ({
        url: "Markets/Put",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "Markets", id: "LIST" }],
    }),

    deleteMarket: builder.mutation<void, number>({
      query: id => ({
        url: `Markets/Delete`,
        method: "DELETE",
        params: { id },
      }),
      invalidatesTags: [{ type: "Markets", id: "LIST" }],
    }),

    getListOfNearbyMarkets: builder.mutation<NearbyMarketsFeatureCollection, { adm0Code: number }>({
      query: ({ adm0Code }) => ({
        url: `Markets/GetListOfNearbyMarkets`,
        method: "GET",
        params: { adm0Code },
      }),
    }),

    getNearbyMarkets: builder.mutation<NearbyMarketData[], { adm0Code: number; long: number; lat: number }>({
      query: ({ adm0Code, lat, long }) => ({
        url: `Markets/GetNearbyMarkets`,
        method: "GET",
        params: { adm0Code, longitude: long, latitude: lat },
      }),
    }),
  }),
})

export const {
  useGetMarketsQuery,
  useAddMarketMutation,
  useUpdateMarketMutation,
  useDeleteMarketMutation,
  useGetListOfNearbyMarketsMutation,
  useGetNearbyMarketsMutation,
} = marketsApi
